export const FINLAND = 'finland';
export const IRELAND = 'ireland';
export const NORTHERN_IRELAND = 'northern_ireland';
export const SCOTLAND = 'scotland';
export const ENGLAND = 'england';
export const WALES = 'wales';
export const USA = 'usa';
export const ESTONIA = 'estonia';



// WEBPACK FOOTER //
// ./src/modules/common/components/areaselect/constants.js